
const serve = () => import('@/views/main/serve/serve.vue')
export default {
  path: '/main/serve',
  name: 'serve',
  component: serve,
  children: []
}
